import Loading from './Loading'
export default Loading;
export { Loading }